import * as React from 'react';
import {authorize, Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {FalconNavigatorHeader, ICustomerPortalService, Party, Types, User} from "@falcon/services";
import {ChangePasswordWidget} from "../../../components/accountDetails/ChangePasswordWidget";
import {ContactDetailsWidget} from "../../../components/accountDetails/ContactDetailsWidget";
import {PersonalDetailsWidget} from "../../../components/accountDetails/PersonalDetailsWidget";
import FalconFooter from "../../../components/navigation/FalconFooter";
import FalconHeader from "../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../utils/PluginTemplates";

interface IProps {

}

interface IState {
    party: Party | undefined,
    user: User | undefined,
    partyLoaded: boolean,
    userLoaded: boolean
}

@authorize
export class MultiPolicyAccountDetailsPage extends React.Component<IProps, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            party: undefined,
            user: undefined,
            partyLoaded: false,
            userLoaded: false
        }
    }

    public componentDidMount(): void {
        this.customerPortalService.getProfile().subscribe((output: Party) => {
            const party: Party = output;

            this.setState({
                party,
                partyLoaded: true
            });
        });

        this.customerPortalService.getUserById().subscribe((user: User) => {
            this.setState({
                user,
                userLoaded: true
            });
        });

        this.pluginTemplates.setPageTitle("Your account details");
    }

    public render(): React.ReactNode {
        if (!this.state.partyLoaded && !this.state.userLoaded) {
            return <Overlay show={true}/>
        } else if (this.state.party) {
            return <>
                <FalconHeader/>
                <div className="plugin account-details-container">
                    <FalconNavigatorHeader back="/dashboard" title="Account details"/>
                    <div className="plugin plugin-panel inner-container inner-content text-center account-details-section">
                        <div className="panel-detail-output-entity account-details-title p-0">
                            <div>
                                <img className="account-details-icon" alt="make-changes" src="/img/account-details.png"/>
                            </div>
                        </div>
                        <div>
                            <PersonalDetailsWidget party={this.state.party}/>
                            <div className="w-100">
                                <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                            </div>
                            <ContactDetailsWidget party={this.state.party} hasIdp={this.state.party.hasIdp}/>
                            <div className="w-100">
                                <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                            </div>
                            {this.state.user && !this.state.party.hasIdp && <ChangePasswordWidget/>}
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, `/dashboard/`)}
                </div>
                <FalconFooter/>
            </>
        }

        return <></>
    }
}
